<mat-form-field
  *ngIf="dropDownData && !isCustomDropdown"
  [appearance]="configuration && configuration.outline ? configuration.outline : ''"
  [ngClass]="configuration && configuration.className ? configuration.className : ''"
>
  <mat-label *ngIf="configuration && configuration.labelValue">{{
    configuration.labelValue
  }}</mat-label>
  <span
    matPrefix
    class="mat-icon-prefix-select"
    *ngIf="configuration && configuration.matIconPrefixMatSelect"
    ><mat-icon>{{ configuration.matIconPrefixMatSelect }} home</mat-icon></span
  >

  <mat-select
    [placeholder]="
      configuration && configuration.placeholderValue
        ? configuration.placeholderValue
        : 'Select the data'
    "
    class="viavi-dropdown"
    [multiple]="configuration && configuration.isMultiselect"
    [disableOptionCentering]="configuration && configuration.isDisableOptionCentering"
    [disableRipple]="configuration && configuration.isDisableRipple"
    [disabled]="configuration && configuration.isDisabled"
    (selectionChange)="valueChanged($event)"
    [panelClass]="configuration && configuration.panelClass ? configuration.panelClass : ''"
  >
    <mat-form-field class="mat-option" *ngIf="configuration && configuration.isSearchable">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        placeholder="search"
        class="search"
        (keyup)="onKey($event.target.value)"
        (keydown)="$event.stopPropagation()"
      />
    </mat-form-field>
    <mat-option *ngFor="let data of filteredDropDownData" [value]="data.value">
      {{ data.value }}
    </mat-option>
    <mat-option *ngIf="filteredDropDownData.length == 0" disabled>
      <span>No data found</span>
    </mat-option>
  </mat-select>
</mat-form-field>

<!-- Custom dropdown  -->

<mat-form-field
  [appearance]="configuration && configuration.outline ? configuration.outline : ''"
  *ngIf="dropDownData && isCustomDropdown"
  class="container"
  [ngClass]="configuration && configuration.className ? configuration.className : ''"
>
  <mat-label *ngIf="configuration && configuration.labelValue">{{
    configuration.labelValue
  }}</mat-label>
  <mat-select
    #mySelect
    [placeholder]="
      configuration && configuration.placeholderValue
        ? configuration.placeholderValue
        : 'Select the data'
    "
    class="viavi-dropdown"
    [multiple]="configuration && configuration.isMultiselect"
    [disableOptionCentering]="configuration && configuration.isDisableOptionCentering"
    [disableRipple]="configuration && configuration.isDisableRipple"
    [disabled]="configuration && configuration.isDisabled"
    (selectionChange)="valueChanged($event)"
    [ngClass]="{
      multiple: configuration && configuration.isMultiselect
    }"
    [panelClass]="configuration && configuration.panelClass ? configuration.panelClass : ''"
    (openedChange)="openChange($event)"
    [(value)]="
      configuration && configuration.isMultiselect
        ? selected
        : filteredDropDownData.length !== 0
        ? filteredDropDownData[selectedIndex]
        : selected
    "
  >
    <mat-select-trigger class="select-trigger">
      <mat-icon
        matprefix
        *ngIf="!configuration?.isLogoImage && configuration && configuration.selectTriggerMatIcon"
        class="select-trigger-icon"
        >{{ configuration.selectTriggerMatIcon }}</mat-icon
      >

      <ng-container
        *ngIf="configuration && !configuration.isHideSelectedValue; else defaulrTriggerValue"
      >
        <ng-container *ngIf="configuration?.isLogoImage">
          <logo-widget
            *ngIf="selected?.subContent"
            [serviceUrl]="selected?.subContent"
            [defaultUrl]="'images/cloud.svg'"
            [styleInfo]="'logo-50-wide'"
          ></logo-widget>
        </ng-container>

        <ng-container
          *ngIf="!configuration?.isLogoImage && configuration && configuration.selectTriggerImgSrc"
        >
          <img
            src="{{ configuration.selectTriggerImgSrc }}"
            alt="selectTriggerimageSrc"
            class="select-trigger-img"
          />
        </ng-container>
        <ng-container *ngIf="selected">
          <div class="selected-header">
            <div>
              <span class="header-title">{{ selected.value }}</span>
            </div>
            <div>
              <span class="location-name">{{ selected?.location }}</span>
            </div>
            <div
              class="select-trigger-subtitle position-absolute"
              *ngIf="configuration && !configuration.isHideAliasInTrigger"
            >
              <div
                class="subcontent"
                *ngIf="selected.subContent && configuration && !configuration.hideSubContent"
              >
                <span class="sub-content" title="{{ selected.subContent }}">{{
                  selected.subContent
                }}</span>
                <span *ngIf="selected.alias" class="alias"> {{ selected.alias }} </span>
              </div>
              <div
                *ngIf="selected.subContent3 && configuration && configuration.hideSubContent"
                class="zero-paddding"
              >
                <span class="sub-content zero-paddding">{{ selected.subContent3 }}</span>
              </div>
              <div class="description selected-sub-details" *ngIf="selected.selectedSubDetails">
                {{ selected.selectedSubDetails }}
              </div>
              <div
                *ngIf="configuration && configuration.isWarningAvailable"
                class="warning-text"
                [ngClass]="selected.warningClass"
              >
                <div class="icon mdi" [ngClass]="selected.warningIcon"></div>
                <span class="warning-msg ng-star-inserted">{{ selected.warningMsg1 }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="selected && selected.length > 0">
          <ng-container *ngFor="let selectedValue of selected">
            {{ selectedValue.value }}
            <div class="select-trigger-subtitle">
              <div *ngIf="selectedValue.subContent">{{ selectedValue.subContent }}</div>
              <div *ngIf="selected.selectedSubDetails">
                {{ selected.selectedSubDetails }}
              </div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container
          class="select-trigger-action-button"
          *ngIf="configuration && configuration.isEditInSelectTrigger"
        >
          <mat-icon class="edit-button" (click)="editHub(selected); $event.stopPropagation()"
            >edit</mat-icon
          >
        </ng-container>
      </ng-container>
      <ng-template #defaulrTriggerValue>
        <ng-container>
          <ng-container *ngIf="configuration && configuration.selectTriggerImgSrc">
            <img
              src="{{ configuration.selectTriggerImgSrc }}"
              alt="selectTriggerimageSrc"
              class="select-trigger-img"
            />
          </ng-container>
          <span class="default-select-trigger-value">
            {{ configuration && configuration.defaultSelectTriggerValue }}</span
          >
        </ng-container>
      </ng-template>
    </mat-select-trigger>

    <mat-form-field class="mat-option" *ngIf="configuration && configuration.isSearchable">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        placeholder="search"
        class="search"
        (keyup)="onKey($event.target.value)"
        (keydown)="$event.stopPropagation()"
        [(ngModel)]="searchField"
      />
    </mat-form-field>

    <mat-divider></mat-divider>
    <div class="custom-panel">
      <ng-container
        *ngIf="configuration && configuration.isMultiselect && configuration.isSelectAll"
      >
        <div class="mat-option" *ngIf="filteredDropDownData.length !== 0">
          <mat-checkbox
            (change)="selectAllToggle($event)"
            class="select-all-checkbox"
            color="primary"
            [checked]="isCheckedAll()"
          >
            <span class="title">Select all</span></mat-checkbox
          >
        </div>
        <mat-divider></mat-divider>
      </ng-container>

      <mat-option
        *ngFor="let data of filteredDropDownData; let index = index"
        [value]="data"
        class="multiline-mat-option"
        [ngClass]="{ 'hide-checkbox': data?.subContent2 && data?.subContent2.length >= 2 }"
        (click)="optionClicked(data)"
        [disabled]="data?.disabled && !data.checked"
      >
        <div (click)="handleAgentAndSiteClick()">
          <span class="header-title">
            <ng-container *ngIf="!configuration?.isLogoImage && data.matOptionprefixMatIcon">
              <mat-icon id="mat-option-prefix-icon" class="mat-option-prefix-icon">{{
                data.matOptionprefixMatIcon
              }}</mat-icon>
            </ng-container>
            <ng-container *ngIf="!configuration?.isLogoImage && data.matOptionprefixSrcImage">
              <img class="mat-option-prefix-img" src="{{ data.matOptionprefixSrcImage }}" />
            </ng-container>
            <ng-container *ngIf="configuration?.isLogoImage">
              <logo-widget
                class="image-detail"
                *ngIf="data?.subContent"
                [serviceUrl]="data?.subContent"
                [defaultUrl]="'images/cloud.svg'"
                [styleInfo]="'logo-50-wide'"
              ></logo-widget> </ng-container
            ><i
              [ngClass]="{
                'active-status': !data.disabled,
                'warning-status': data.running,
                'disabled-status': data.disabled
              }"
              [class]="data.statusIcon"
            >
            </i>
            <span innerHTML="{{ data.value | highlight: searchField }}"></span
          ></span>
          <div class="location-details" *ngIf="data.subContent">
            <span
              class="location-name"
              *ngIf="data?.location"
              innerHTML="{{ data.location | highlight: searchField }}"
            ></span>
            <span
              class="location"
              innerHTML="{{ data.subContent | highlight: searchField }}"
            ></span>
            <span
              *ngIf="data.subContent1"
              class="sub-content1"
              innerHTML="{{ data.subContent1 | highlight: searchField }}"
            ></span>

            <span
              class="alias"
              *ngIf="data.alias"
              class="alias"
              innerHTML="{{ data.alias | highlight: searchField }}"
            ></span>
            <span
              *ngIf="
                (!data.subContent2 && data.type) ||
                (data.subContent2 && data.subContent2.length === 0 && data.type)
              "
              class="alias"
              class="alias"
              innerHTML="{{ data.type | highlight: searchField }}"
            ></span>
            <div
              class="checkbox-container"
              *ngFor="let item of data?.subContent2; let i = index"
              (click)="$event.stopPropagation()"
            >
              <mat-checkbox
                class="select-all-checkbox"
                color="primary"
                [checked]="item.value"
                (change)="changeReflector($event, item, data)"
              ></mat-checkbox>
              <span class="reflector">
                <i class="mdi mdi-repeat"></i>
                <span>Reflector - {{ i + 1 }} </span>
                <span innerHTML="{{ item.reflectorIp | highlight: searchField }}"></span>
                <span *ngIf="item?.phyId">-{{ item?.phyId }}</span>
                <div class="test-name">{{ item.testName }}</div>
              </span>
            </div>
            <button
              mat-button
              class="sub-details-button"
              aria-label="Show sub details"
              matTooltipPosition="above"
              matTooltipShowDelay="500"
              matTooltip="Show agents"
              (click)="openSubDetails(data); $event.stopPropagation()"
              *ngIf="data.isAction"
            >
              <i class="material-icons">more_horiz</i>
            </button>
          </div>
        </div>
        <mat-list
          *ngIf="data.isAction && data.subDetails && data.subDetailsVisibility"
          class="list-of-sub-details"
        >
          <ng-container *ngFor="let sub of data.subDetails">
            <mat-list-item *ngIf="sub.isOpen" (click)="handleSubDetailsClick(sub)">
              <mat-icon matprefix class="mat-list-icon" *ngIf="sub.matIcon">{{
                sub.matIcon
              }}</mat-icon>
              <img
                src="{{ sub.srcImageUrl }}"
                alt="sub_srcImageUrl"
                class="sub-details-img-src"
                *ngIf="sub.srcImageUrl"
              />
              <span
                class="subDetailValue"
                innerHTML="{{ sub.value | highlight: searchField }}"
              ></span>
            </mat-list-item>
          </ng-container>
        </mat-list>
        <mat-divider *ngIf="configuration && configuration.isDividerEnableInOptions"></mat-divider>
      </mat-option>
    </div>
    <!-- custom dropdown footer -->
    <footer
      *ngIf="configuration && configuration.isButtonEnabled && filteredDropDownData.length !== 0"
    >
      <button
        mat-flat-button
        (click)="doneClick()"
        [disabled]="selectedOptions?.length < configuration.minimumSelectedEndpoint"
      >
        {{ configuration && configuration.buttonTitle ? configuration.buttonTitle : 'Ok' }}
      </button>
    </footer>

    <!-- No data found error in search  -->
    <mat-option *ngIf="filteredDropDownData.length == 0" disabled [value]="selected">
      <span>No data found</span>
    </mat-option>
  </mat-select>
  <div *ngIf="configuration && configuration.showCount" class="list count-section">
    <div class="count-text">
      <span class="count-color">Total Devices:</span>
      <span class="count-value"> {{ dropDownData?.length }}</span>
    </div>
    <div class="count-text">
      <span class="count-color">Selected: </span>
      <span class="count-value"> {{ selectedOptions?.length || 0 }}</span>
    </div>
  </div>
</mat-form-field>
<div
  *ngIf="configuration && configuration.isCustomSelectTrigger && isDone && selectedOptions?.length"
  class="selected-options"
>
  <mat-list>
    <mat-list-item *ngFor="let selectedValue of selectedOptions" class="selected-list-item">
      <ng-container
        *ngIf="configuration && configuration.selectTriggerImgSrc && !configuration.enableRowIcons"
      >
      </ng-container>
      <ng-container *ngIf="configuration && configuration.enableRowIcons">
        <mat-icon class="{{ selectedValue.dataInfo.icon }}"></mat-icon>
      </ng-container>

      <div class="selected-vlaues-container">
        <span class="header-title">
          <i
            [ngClass]="{
              'active-status': !selectedValue.disabled,
              'warning-status': selectedValue.running,
              'disabled-status': selectedValue.disabled
            }"
            [class]="selectedValue.statusIcon"
          >
          </i
          >{{ selectedValue.value }}</span
        >
        <span class="location">{{ selectedValue?.location }}</span>
        <span class="location"> {{ selectedValue.subContent }}</span>
        <span class="sub-content1"> {{ selectedValue.subContent1 }}</span>
        <span class="error-msg">{{ selectedValue.errorMsg }}</span>
      </div>
      <div class="selected-value-actions">
        <i
          class="mdi mdi-circle-edit-outline"
          (click)="editEndpoint(selectedValue)"
          *ngIf="configuration.isEndpointEditable"
        ></i>
        <i class="mdi mdi-close-circle-outline" (click)="removeEndpoint(selectedValue)"></i>
      </div>
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-list>
</div>
